// extracted by mini-css-extract-plugin
export default {"showsImg":"HotTopicCard_showsImg__TY2Ld"};